<template>
  <div class="history-result mt-2 mb-4">
    <div class="history-p">
      <div class="history-header text-center mb-2">ຜົນການອອກເລກລາງວັນ</div>
      <table>
        <tbody>
          <tr>
            <td><strong>ງວດວັນທີ່</strong></td>
            <td width="18%"><strong>ເລກ 5 ໂຕ</strong></td>
            <td width="18%"><strong>ເລກ 3 ໂຕ</strong></td>
            <td width="18%"><strong>ເລກ 2 ໂຕເທິ່ງ</strong></td>
            <td width="18%"><strong>ເລກ 2 ໂຕລຸ່ມ</strong></td>
          </tr>
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.lotto_date | date }}</td>
            <td>{{ item.results | result('digit5') }}</td>
            <td>{{ item.results | result('digit3') }}</td>
            <td>{{ item.results | result('digit2_top') }}</td>
            <td>{{ item.results | result('digit2_bottom') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--<div class="history-footer"></div>-->
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

export default {
  name: 'HistoryResults',
  data() {
    return {
      data: []
    }
  },
  computed: {
    items() {
      return this.data
    }
  },
  methods: {
    getResults() {
      LottoService.getHistories().then((response)=>{
        if(response.status === 'success') {
          this.data = response.data
        }
      })
    }
  },
  created() {
    this.getResults()
  },
  filters: {
    date(param) {
      return moment(param).format("LL")
    },
    result(results, digit) {
      if(results) {
        return results[digit]
      }else {
        return '-'
      }
    }
  },
}

</script>
<style lang="scss" scoped>
.history-result {
  //margin-top: 15px;
  //border: 1px solid #eee;
  //min-height: 150px;
  color: #000;
  //padding: 15px;
  background-color: #fff;
  /*background: url('../../assets/theme/history-bg.png') no-repeat top center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;*/

  .history-p {
    //padding: 15px;
  }

  .history-header {
    /*background: url('../../assets/theme/history-header-bg.png') no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;*/
    color: #FFF;
    font-size: 26px;
    background-color: darkgoldenrod;
    border-top: 2px solid darkgoldenrod;
    border-bottom: 3px solid darkgoldenrod;
  }

  .history-footer {
    height: 6px;
    background-color: #fff;
    background: url('../../assets/theme/history-bg.png') no-repeat bottom center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  table {
    width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #FFF;

    thead {
      tr {
        th {
          text-align: center;
          font-size: 26px;
          /*background: url('../../assets/theme/bg4.png') no-repeat center top;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;*/
        }
      }
    }

    tbody {
      tr {
        td {
          text-align: center;
          border: 1px solid #999;
          padding: 5px;
          font-size: 16px;
        }
      }
    }
  }
}

@media (max-width: 1020px) {
  .history-result {
    //margin-top: 5px;
  }
}

@media (max-width: 768px) {
  .history-result .history-p {
    padding: 0px;
  }
}
</style>
